<div class="formModal">
  <div class="modal-header">
    <h5 class="modal-title" id="formModalLabel">
      <i class="fas fa-key me-2"></i>
      Change Password
    </h5>
    <button type="button" class="btn-close btn-close-white" (click)="onCancel()" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <div class="container-fluid">
      <!-- Form -->
      <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
        
        <!-- Password Section -->
        <div class="section-card">
          <div class="section-header">
            <h6 class="section-title">
              <i class="fas fa-lock me-2"></i>
              Password Details
            </h6>
          </div>
          <div class="section-body">
            <div class="row">
              <div class="col-md-12">
                <div class="mb-3">
                  <label for="currentPassword" class="form-label">Current Password<span class="text-danger">*</span></label>
                  <div class="input-group">
                    <input 
                      [type]="showCurrentPassword ? 'text' : 'password'" 
                      id="currentPassword" 
                      class="form-control" 
                      formControlName="currentPassword"
                      [class.is-invalid]="isFieldInvalid('currentPassword')" 
                      placeholder="Enter current password">
                    <button 
                      type="button" 
                      class="btn btn-outline-secondary" 
                      (click)="toggleCurrentPasswordVisibility()">
                      <i [class]="showCurrentPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                    </button>
                  </div>
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('currentPassword')">
                    {{ getFieldError('currentPassword') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="mb-3">
                  <label for="newPassword" class="form-label">New Password<span class="text-danger">*</span></label>
                  <div class="input-group">
                    <input 
                      [type]="showNewPassword ? 'text' : 'password'" 
                      id="newPassword" 
                      class="form-control" 
                      formControlName="newPassword"
                      [class.is-invalid]="isFieldInvalid('newPassword')" 
                      placeholder="Enter new password">
                    <button 
                      type="button" 
                      class="btn btn-outline-secondary" 
                      (click)="toggleNewPasswordVisibility()">
                      <i [class]="showNewPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                    </button>
                  </div>
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('newPassword')">
                    {{ getFieldError('newPassword') }}
                  </div>
                  <small class="form-text text-muted">
                    Password must be at least 14 characters long and contain uppercase, lowercase, number, and special character.
                  </small>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="mb-3">
                  <label for="confirmPassword" class="form-label">Confirm New Password<span class="text-danger">*</span></label>
                  <div class="input-group">
                    <input 
                      [type]="showConfirmPassword ? 'text' : 'password'" 
                      id="confirmPassword" 
                      class="form-control" 
                      formControlName="confirmPassword"
                      [class.is-invalid]="isFieldInvalid('confirmPassword')" 
                      placeholder="Confirm new password">
                    <button 
                      type="button" 
                      class="btn btn-outline-secondary" 
                      (click)="toggleConfirmPasswordVisibility()">
                      <i [class]="showConfirmPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                    </button>
                  </div>
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('confirmPassword')">
                    {{ getFieldError('confirmPassword') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
      </form>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary ms-2" (click)="onCancel()">
      Cancel
    </button>
    <button 
      type="submit" 
      class="btn btn-primary ms-2" 
      (click)="onSubmit()">
      Save
    </button>
  </div>
</div>